module.exports = __webpack_public_path__ + "static/media/dekentje14.ab883f38.webp";